import { render, staticRenderFns } from "./Digital.vue?vue&type=template&id=643ebbe1&"
import script from "./Digital.vue?vue&type=script&lang=ts&"
export * from "./Digital.vue?vue&type=script&lang=ts&"
import style0 from "./Digital.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports